import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AnonymousContentPage } from 'shared.components/anonymous-content-page/anonymous-content-page';

@Component({
  selector: '[nc-unauthorized]',
  templateUrl: './unauthorized.component.html',
  standalone: false,
})
export class UnauthorizedComponent extends AnonymousContentPage {
  constructor(private router: Router) {
    super();
  }

  onHomeButtonClicked(): void {
    this.router.navigate(['/']);
  }
}
